import React from 'react'
import jwtDecode from 'jwt-decode'
import {Redirect, Route} from 'react-router-dom'
import checkToken from './Functions/checkToken'

const AdminRoute = ({component: Component, ...rest}) => {
  const token = JSON.parse(localStorage.getItem('tokens'))
  let authenticated = false
  let administrator = false
  try {
    authenticated = token !== null && checkToken(token)
    if (authenticated) {
      const claims = jwtDecode(token)
      administrator = Number(claims.role ?? claims.role_id ?? claims.roleId) === 1
    }
  } catch {
    authenticated = false
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authenticated) return <Redirect to='/login' />
        if (!administrator) return <Redirect to='/' />
        return <Component {...props} />
      }}
    />
  )
}

export default AdminRoute
